import { z } from "zod";

/**
 * Outlook OAuth connection settings — Zod validation schema, and the ONLY
 * definition of this shape: `OutlookConnectionSettings` in
 * `shared/domain/oauth/service-metadata.types.ts` is inferred from it.
 *
 * Every key the backend writes into an Outlook connection's `settings` is
 * declared here. This arm is a `z.object`, so it STRIPS undeclared keys, and
 * every `settings` write runs through it (`oauthSettingsToPrisma` →
 * `parseOAuthConnectionSettings`) — a key the Outlook watch manager writes and
 * this schema omits is silently deleted from every row of this shape.
 *
 * The subscription's Graph `clientState` is NOT here: it is a secret whose
 * lifecycle is the subscription's, so it lives encrypted in the
 * `OAuthConnection.webhookClientState` column, which no reconnect writes.
 */
export const OutlookConnectionSettingsSchema = z.object({
  service: z.literal("OUTLOOK"),
  email: z.string().nullable(),
  subscriptionId: z.string().nullable(),
  subscriptionExpiresAt: z.coerce.date().nullable(),
  /**
   * The shared mailbox the live Graph subscription targets, `null` for `/me`.
   * Compared on renewal: a change recreates the subscription.
   */
  webhookSharedMailbox: z.string().nullable().optional()
});
